<div class="grid field col-12">
  <div class="grid field col-12">
    <h1>Workbook Log</h1>
    @if (!everythingReady) {
      <p-progressSpinner></p-progressSpinner>
    }
  </div>
  @if (everythingReady) {
    <div class="grid field col-12">
      <!-- Time -->
      <div class="grid field col-12">
        <div class="col-12 md:col-2">
          <label>Log Time</label>
        </div>
        <div class="col-12 md:col-6">
          <p-date-picker [(ngModel)]="workbookLogCalendarTime" [showIcon]="true" [showTime]="true" [hourFormat]="'24'"
            yearRange="2018:2038" (onClose)=validateTime(false) [style]="{'width':'200px'}">
          </p-date-picker>
        </div>
        @if (modelInvalid) {
          <div class="col-12 md:col-6">
            @if (modelInvalid && !workbookLogCalendarTime) {
              <div class="grid field col-12">
                <label style="color:red; font-weight:bold;">Log time is required!</label>
              </div>
            }
            @if (modelInvalid && badTimeRange) {
              <div class="grid field col-12">
                <label style="color:red; font-weight:bold;">Log time must be within Job's defined start and end
                times!</label>
              </div>
            }
            @if (modelInvalid && timeExists) {
              <div class="grid field col-12">
                <label style="color:red; font-weight:bold;">Another log with this time already exists!</label>
              </div>
            }
          </div>
        }
      </div>
      <!-- Activity -->
      <div class="grid field col-12">
        <div class="col-12 md:col-2">
          <label>Activity</label>
        </div>
        <div class="col-12 md:col-6">
          <p-select [options]="activities" [(ngModel)]="workbookLog.activity" placeholder="Select Activity"
          [style]="{'width':'200px'}" (onChange)="activityChosen()"></p-select>
          @if (modelInvalid && !workbookLog.activity) {
            <div class="grid field col-12">
              <label style="color:red; font-weight:bold;">Activity is required!</label>
            </div>
          }
        </div>
      </div>
      @if (measurementsToShow && measurementsToShow.length > 0) {
        @for (measurement of measurementsToShow; track measurement) {
          <div class="grid field col-12">
            <div class="col-12 md:col-2">
              <label>{{measurement.measurementDisplayName}}</label>
            </div>
            @if (isTextConfig(measurement)) {
              <div class="col-12 md:col-10"  >
                @if (isTextConfig(measurement)) {
                  <input type="text" pInputText class="w-full"
                    placeholder="Enter {{measurement.measurementDisplayName}} value"
                    [(ngModel)]="workbookLog[measurement.workbookPropertyName]" />
                }
              </div>
            }
            @if (isNumberConfig(measurement)) {
              <div class="col-8 md:col-10">
                @if (isNumberConfig(measurement)) {
                  <input type="number" pInputText style="max-width: 200px;"
                    placeholder="Enter {{measurement.measurementDisplayName}} value"
                    [(ngModel)]="workbookLog[measurement.workbookPropertyName]" class="w-full" />
                }
                <label class="ml-1" >{{getUnitName(measurement.unitOfMeasurementId)}}</label>
                @if (isOutOfRange(measurement)) {
                  <p-message severity="error">{{ getRangeError(measurement) }}</p-message>
                }
              </div>
              <!-- <div class="col-4 md:col-2">
              <label>{{getUnitName(measurement.unitOfMeasurementId)}}</label>
            </div> -->
          }
          @if (isLookupConfig(measurement)) {
            <div class="col-12 md:col-6">
              <p-select [options]="measurement.lookupChoicesAsSelectItems"
                [(ngModel)]="workbookLog[measurement.workbookPropertyName]" placeholder="Select Value"
              [style]="{'width':'200px'}"></p-select>
            </div>
          }
          @if (modelInvalid && !workbookLog[measurement.workbookPropertyName]) {
            <div class="grid field col-12">
              <label style="color:red; font-weight:bold;">{{measurement.measurementName}} is required!</label>
            </div>
          }
        </div>
      }
    }
    @if (!isNew) {
      <div class="grid field col-12">
        <div class="col-12 md:col-2">
          <label>Created By</label>
        </div>
        <div class="col-12 md:col-6">
          <label>{{workbookLog.CreatedBy}}</label>
        </div>
      </div>
    }
    <!-- Action Buttons -->
    <div class="grid field col-12">
      <button pButton (click)="saveWorkbookLog(false)"
                [disabled]="saving" [ngClass]="{ 'action-button': !saving,
                                 'action-button-disabled': saving }">
        Save
      </button>
      <button pButton (click)="saveWorkbookLog(true)"
                [disabled]="saving || isUserServiceProvider" [ngClass]="{ 'action-button': !saving,
                                 'action-button-disabled': saving }">
        Save and New
      </button>
      <button pButton class="action-button" (click)="returnToWorkbook()">
        Cancel
      </button>
    </div>
  </div>
}
</div>
